import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'

@Injectable()
export class StaticContentTemplatesService {
  constructor(private http: HttpClient) {}

  public fetchStaticContentTemplates(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/staticContentTemplate/list`
    return this.http.post(url, params)
  }
  public fetchStaticContentTemplate(id: string, lang: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/staticContentTemplate/${id}/${lang}`
    return this.http.get(url, {})
  }

  public deleteStaticContentTemplate(id: string): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/staticContentTemplate/${id}`
    return this.http.delete(url)
  }

  public updateStaticContentTemplate(id: string, params: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/staticContentTemplate/${id}/${params.language.iso2code}`
    return this.http.post(url, params)
  }
}
